export default {
  BOOKINGS:    'bookings_requests',
  EVENTS:      'upcoming_events',
  FAVORITES:   'my_favourites',
  MEMBERSHIPS: 'my_memberships'
};
